import React, { useState } from 'react';
import '../styles/ForgetPassword.scss';
import { Mail } from 'lucide-react';
import logo from '../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';

const ForgetPassword =()=> {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) =>
    /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    // Simulate API request
    setTimeout(() => {
      setIsLoading(false);
      setSuccessMessage(`Reset link sent to ${email}`);
      setEmail('');
    }, 2000);
  };
  const handleSignIn = () => {
    navigate('/signin');
  };

  return (
    <div className="forget-password-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="signup-header">
              <div className="brand-logo">
                <img src={logo} alt="getam Logo" className="logo-icon me-2" />
              </div>
              <p className="brand-subtitle">Recover your account</p>
            </div>

            <div className="signup-card">
              <h2 className="signup-title h3">Forgot Password</h2>

              {successMessage && (
                <div className="alert alert-success">
                  {successMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-floating mb-3">
                  <input
                    type="email"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <label htmlFor="email">Email Address</label>
                  {error && <span className="error-message">{error}</span>}
                </div>

                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn btn-primary-custom w-100"
                >
                  {isLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="login-link mt-3 text-center">
                <p>
                  Remember your password?{' '}
                  <a href="#" onClick={handleSignIn}>
                    Sign In
                  </a>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ForgetPassword;
